import React from 'react'
import { Avatar, Box, Flex, Text } from '@chakra-ui/core'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { useUserName } from 'hooks/useUserName'

interface UserSummaryProps {
  uid: string
}

export const UserSummary: React.FC<UserSummaryProps> = ({ uid }) => {
  const { retailUsersObject, mappedGroupsByUsers } = useSelector((state: RootState) => state.config.config)
  const userName = useUserName(uid)

  const user = retailUsersObject?.[uid]
  const userGroup = mappedGroupsByUsers?.[uid]?.[0] ?? ''

  return (
    <Flex alignItems="center" style={{ gap: '12px' }} py="8px" px="12px">
      <Avatar size="sm" name={userName} src={user?.profile_img_url} />
      <Box>
        <Text fontWeight="600" fontSize="14px">
          {userName}
        </Text>
        <Text fontSize="12px" color="gray.500">
          {userGroup}
        </Text>
      </Box>
    </Flex>
  )
}
